/* eslint-disable import/no-anonymous-default-export */

import { decodeJWT } from 'helpers/jwt/decode';

const sanitizeProps = (obj) => {
	return JSON.parse(JSON.stringify(obj));
};

const decodeUserJWT = (jwt, extraUserData) => {
	if (jwt) {
		const {
			auth,
			email,
			user_hash,
			user_id,
			user: userName,
			created_at,
			activated_at,
			intercom_app_id,
			account_id,
			is_account_master,
			can_manage_users,
			dealership_name,
			city,
			state,
			zipcode,
			carwave,
			normal_image,
			admin_user_id,
			on_behalf_of,
			dealerships_where_user_is_master_buyer,
			show_dealership_purchases,
			show_bin_on_search,
		} = decodeJWT(jwt) || {};

		const isMasterUserOnBehalfOfOther = Boolean(on_behalf_of?.user_id);
		let masterUserData = null;
		if (isMasterUserOnBehalfOfOther) {
			masterUserData = {
				user_id,
				user: userName,
				dealership_name,
				normal_image,
			};
		}

		const user = {
			id: user_id,
			auth,
			jwt,
			email,
			user_hash: user_hash || null,
			user_id,
			user: userName,
			created_at: created_at || null,
			user_activation_date: activated_at,
			intercom_app_id: intercom_app_id || null,
			account_id: account_id || null,
			is_account_master: is_account_master || null,
			can_manage_users: can_manage_users || null,
			dealership_name: dealership_name || null,
			city,
			state,
			zipcode,
			carwave,
			normal_image,
			admin_user_id,
			on_behalf_of: on_behalf_of || null,
			dealerships_where_user_is_master_buyer: dealerships_where_user_is_master_buyer || null,
			show_dealership_purchases: show_dealership_purchases || null,
			show_bin_on_search: show_bin_on_search ?? null,
			...extraUserData,
			// when a master user is impersonating another user we will overwrite user data with on_behalf_of data..
			// master user data will be on masterUserData (only populated when master user is impersonating another user)
			masterUserData,
			...on_behalf_of, // <-- this will overwrite user data like userId, user, dealership and image
		};

		return sanitizeProps(user);
	} else {
		return {
			auth: false,
			jwt: null,
		};
	}
};

export default decodeUserJWT;
